import {combineReducers } from 'redux';
import { IAppState } from '../store/IAppState';
import { counterReducer } from './counter.reducer';
import { recommendationReducer } from './recommendation.reducer';
import { labReducer } from './lab.reducer';
import { approvedQcPlanReducer } from './approved-qc-plan.reducer';
import { qcPlanDetailReducer } from './qc-plan-detail.reducer';
import { qcPlanFlagReducer } from './qc-plan-flag.reducer';
import { qcPlanDetailOptionReducer } from './qc-plan-detail-option.reducer';
import { sessionReducer } from './session.reducer';
import { onboardingReducer } from './onboarding.reducer';
import { commonDataReducer } from './common-data.reducer';
import { progressReducer } from './progress.reducer';

export default combineReducers<IAppState>({
    counterState: counterReducer,
    recommendationState: recommendationReducer,
    labState: labReducer,
    approvedQcPlanState: approvedQcPlanReducer,
    qcPlanDetailState: qcPlanDetailReducer,
    qcPlanFlagState: qcPlanFlagReducer,
    qcPlanDetailOptionState: qcPlanDetailOptionReducer,
    sessionState: sessionReducer,
    onboardingState: onboardingReducer,
    commonDataState: commonDataReducer,
    progressState: progressReducer
});



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/index.ts